import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const ApiPageContainer = styled.div`
    margin: 0 auto;
`;

export const tabsStyle = css`
    ul {
        padding-bottom: 26px;
    }
`;
